webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    MainNav: __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer'
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'jingle'
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav'
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'presentation'
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'processing'
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_jszip_dist_jszip_min_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_jszip_dist_jszip_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_jszip_dist_jszip_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_jszip_lib_jszip_utils_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_jszip_lib_jszip_utils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_jszip_lib_jszip_utils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_file_saver_FileSaver_min_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_file_saver_FileSaver_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_file_saver_FileSaver_min_js__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      is_active: false,
      is_hidden: true,
      image: "",
      ressources_array: ["LogoEsipeCustomPack/print/eisc_rvb_print_grand.eps", "/static/ressources/eisc_rvb_print_grand.eps", "LogoEsipeCustomPack/print/eisc_rvb_print_moyen.eps", "/static/ressources/eisc_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/eisc_rvb_print_petit.eps", "/static/ressources/eisc_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_grand.png", "/static/ressources/eisc_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_moyen.png", "/static/ressources/eisc_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_petit.png", "/static/ressources/eisc_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/eisc_cmjn_print_grand.eps", "/static/ressources/eisc_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/eisc_cmjn_print_moyen.eps", "/static/ressources/eisc_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/eisc_cmjn_print_petit.eps", "/static/ressources/eisc_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_grand.png", "/static/ressources/eisc_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_moyen.png", "/static/ressources/eisc_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_petit.png", "/static/ressources/eisc_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/eisc_gris_print_grand.eps", "/static/ressources/eisc_gris_print_grand.eps", "LogoEsipeCustomPack/print/eisc_gris_print_moyen.eps", "/static/ressources/eisc_gris_print_moyen.eps", "LogoEsipeCustomPack/print/eisc_gris_print_petit.eps", "/static/ressources/eisc_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/eisc_gris_numerique_grand.png", "/static/ressources/eisc_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/eisc_gris_numerique_moyen.png", "/static/ressources/eisc_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/eisc_gris_numerique_petit.png", "/static/ressources/eisc_gris_numerique_petit.png", "LogoEsipeCustomPack/print/eisc_blanc_print_grand.eps", "/static/ressources/eisc_blanc_print_grand.eps", "LogoEsipeCustomPack/print/eisc_blanc_print_moyen.eps", "/static/ressources/eisc_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/eisc_blanc_print_petit.eps", "/static/ressources/eisc_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_grand.png", "/static/ressources/eisc_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_moyen.png", "/static/ressources/eisc_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_petit.png", "/static/ressources/eisc_blanc_numerique_petit.png", "LogoEsipeCustomPack/print/gc_rvb_print_grand.eps", "/static/ressources/gc_rvb_print_grand.eps", "LogoEsipeCustomPack/print/gc_rvb_print_moyen.eps", "/static/ressources/gc_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/gc_rvb_print_petit.eps", "/static/ressources/gc_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/gc_rvb_numerique_grand.png", "/static/ressources/gc_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/gc_rvb_numerique_moyen.png", "/static/ressources/gc_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gc_rvb_numerique_petit.png", "/static/ressources/gc_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/gc_cmjn_print_grand.eps", "/static/ressources/gc_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/gc_cmjn_print_moyen.eps", "/static/ressources/gc_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/gc_cmjn_print_petit.eps", "/static/ressources/gc_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_grand.png", "/static/ressources/gc_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_moyen.png", "/static/ressources/gc_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_petit.png", "/static/ressources/gc_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/gc_gris_print_grand.eps", "/static/ressources/gc_gris_print_grand.eps", "LogoEsipeCustomPack/print/gc_gris_print_moyen.eps", "/static/ressources/gc_gris_print_moyen.eps", "LogoEsipeCustomPack/print/gc_gris_print_petit.eps", "/static/ressources/gc_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/gc_gris_numerique_grand.png", "/static/ressources/gc_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/gc_gris_numerique_moyen.png", "/static/ressources/gc_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gc_gris_numerique_petit.png", "/static/ressources/gc_gris_numerique_petit.png", "LogoEsipeCustomPack/print/gc_blanc_print_grand.eps", "/static/ressources/gc_blanc_print_grand.eps", "LogoEsipeCustomPack/print/gc_blanc_print_moyen.eps", "/static/ressources/gc_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/gc_blanc_print_petit.eps", "/static/ressources/gc_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/gc_blanc_numerique_grand.png", "/static/ressources/gc_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/gc_blanc_numerique_moyen.png", "/static/ressources/gc_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gc_blanc_numerique_petit.png", "/static/ressources/gc_blanc_numerique_petit.png", "LogoEsipeCustomPack/print/gm_rvb_print_grand.eps", "/static/ressources/gm_rvb_print_grand.eps", "LogoEsipeCustomPack/print/gm_rvb_print_moyen.eps", "/static/ressources/gm_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/gm_rvb_print_petit.eps", "/static/ressources/gm_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/gm_rvb_numerique_grand.png", "/static/ressources/gm_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/gm_rvb_numerique_moyen.png", "/static/ressources/gm_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gm_rvb_numerique_petit.png", "/static/ressources/gm_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/gm_cmjn_print_grand.eps", "/static/ressources/gm_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/gm_cmjn_print_moyen.eps", "/static/ressources/gm_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/gm_cmjn_print_petit.eps", "/static/ressources/gm_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_grand.png", "/static/ressources/gm_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_moyen.png", "/static/ressources/gm_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_petit.png", "/static/ressources/gm_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/gm_gris_print_grand.eps", "/static/ressources/gm_gris_print_grand.eps", "LogoEsipeCustomPack/print/gm_gris_print_moyen.eps", "/static/ressources/gm_gris_print_moyen.eps", "LogoEsipeCustomPack/print/gm_gris_print_petit.eps", "/static/ressources/gm_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/gm_gris_numerique_grand.png", "/static/ressources/gm_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/gm_gris_numerique_moyen.png", "/static/ressources/gm_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gm_gris_numerique_petit.png", "/static/ressources/gm_gris_numerique_petit.png", "LogoEsipeCustomPack/print/gm_blanc_print_grand.eps", "/static/ressources/gm_blanc_print_grand.eps", "LogoEsipeCustomPack/print/gm_blanc_print_moyen.eps", "/static/ressources/gm_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/gm_blanc_print_petit.eps", "/static/ressources/gm_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/gm_blanc_numerique_grand.png", "/static/ressources/gm_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/gm_blanc_numerique_moyen.png", "/static/ressources/gm_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/gm_blanc_numerique_petit.png", "/static/ressources/gm_blanc_numerique_petit.png", "LogoEsipeCustomPack/print/imac_rvb_print_grand.eps", "/static/ressources/imac_rvb_print_grand.eps", "LogoEsipeCustomPack/print/imac_rvb_print_moyen.eps", "/static/ressources/imac_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/imac_rvb_print_petit.eps", "/static/ressources/imac_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/imac_rvb_numerique_grand.png", "/static/ressources/imac_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/imac_rvb_numerique_moyen.png", "/static/ressources/imac_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/imac_rvb_numerique_petit.png", "/static/ressources/imac_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/imac_cmjn_print_grand.eps", "/static/ressources/imac_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/imac_cmjn_print_moyen.eps", "/static/ressources/imac_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/imac_cmjn_print_petit.eps", "/static/ressources/imac_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_grand.png", "/static/ressources/imac_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_moyen.png", "/static/ressources/imac_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_petit.png", "/static/ressources/imac_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/imac_gris_print_grand.eps", "/static/ressources/imac_gris_print_grand.eps", "LogoEsipeCustomPack/print/imac_gris_print_moyen.eps", "/static/ressources/imac_gris_print_moyen.eps", "LogoEsipeCustomPack/print/imac_gris_print_petit.eps", "/static/ressources/imac_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/imac_gris_numerique_grand.png", "/static/ressources/imac_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/imac_gris_numerique_moyen.png", "/static/ressources/imac_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/imac_gris_numerique_petit.png", "/static/ressources/imac_gris_numerique_petit.png", "LogoEsipeCustomPack/print/imac_blanc_print_grand.eps", "/static/ressources/imac_blanc_print_grand.eps", "LogoEsipeCustomPack/print/imac_blanc_print_moyen.eps", "/static/ressources/imac_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/imac_blanc_print_petit.eps", "/static/ressources/imac_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/imac_blanc_numerique_grand.png", "/static/ressources/imac_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/imac_blanc_numerique_moyen.png", "/static/ressources/imac_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/imac_blanc_numerique_petit.png", "/static/ressources/imac_blanc_numerique_petit.png", "LogoEsipeCustomPack/print/info_rvb_print_grand.eps", "/static/ressources/info_rvb_print_grand.eps", "LogoEsipeCustomPack/print/info_rvb_print_moyen.eps", "/static/ressources/info_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/info_rvb_print_petit.eps", "/static/ressources/info_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/info_rvb_numerique_grand.png", "/static/ressources/info_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/info_rvb_numerique_moyen.png", "/static/ressources/info_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/info_rvb_numerique_petit.png", "/static/ressources/info_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/info_cmjn_print_grand.eps", "/static/ressources/info_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/info_cmjn_print_moyen.eps", "/static/ressources/info_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/info_cmjn_print_petit.eps", "/static/ressources/info_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/info_cmjn_numerique_grand.png", "/static/ressources/info_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/info_cmjn_numerique_moyen.png", "/static/ressources/info_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/info_cmjn_numerique_petit.png", "/static/ressources/info_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/info_gris_print_grand.eps", "/static/ressources/info_gris_print_grand.eps", "LogoEsipeCustomPack/print/info_gris_print_moyen.eps", "/static/ressources/info_gris_print_moyen.eps", "LogoEsipeCustomPack/print/info_gris_print_petit.eps", "/static/ressources/info_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/info_gris_numerique_grand.png", "/static/ressources/info_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/info_gris_numerique_moyen.png", "/static/ressources/info_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/info_gris_numerique_petit.png", "/static/ressources/info_gris_numerique_petit.png", "LogoEsipeCustomPack/print/info_blanc_print_grand.eps", "/static/ressources/info_blanc_print_grand.eps", "LogoEsipeCustomPack/print/info_blanc_print_moyen.eps", "/static/ressources/info_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/info_blanc_print_petit.eps", "/static/ressources/info_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/info_blanc_numerique_grand.png", "/static/ressources/info_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/info_blanc_numerique_moyen.png", "/static/ressources/info_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/info_blanc_numerique_petit.png", "/static/ressources/info_blanc_numerique_petit.png", "LogoEsipeCustomPack/print/mfpi_rvb_print_grand.eps", "/static/ressources/mfpi_rvb_print_grand.eps", "LogoEsipeCustomPack/print/mfpi_rvb_print_moyen.eps", "/static/ressources/mfpi_rvb_print_moyen.eps", "LogoEsipeCustomPack/print/mfpi_rvb_print_petit.eps", "/static/ressources/mfpi_rvb_print_petit.eps", "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_grand.png", "/static/ressources/mfpi_rvb_numerique_grand.png", "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_moyen.png", "/static/ressources/mfpi_rvb_numerique_moyen.png", "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_petit.png", "/static/ressources/mfpi_rvb_numerique_petit.png", "LogoEsipeCustomPack/print/mfpi_cmjn_print_grand.eps", "/static/ressources/mfpi_cmjn_print_grand.eps", "LogoEsipeCustomPack/print/mfpi_cmjn_print_moyen.eps", "/static/ressources/mfpi_cmjn_print_moyen.eps", "LogoEsipeCustomPack/print/mfpi_cmjn_print_petit.eps", "/static/ressources/mfpi_cmjn_print_petit.eps", "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_grand.png", "/static/ressources/mfpi_cmjn_numerique_grand.png", "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_moyen.png", "/static/ressources/mfpi_cmjn_numerique_moyen.png", "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_petit.png", "/static/ressources/mfpi_cmjn_numerique_petit.png", "LogoEsipeCustomPack/print/mfpi_gris_print_grand.eps", "/static/ressources/mfpi_gris_print_grand.eps", "LogoEsipeCustomPack/print/mfpi_gris_print_moyen.eps", "/static/ressources/mfpi_gris_print_moyen.eps", "LogoEsipeCustomPack/print/mfpi_gris_print_petit.eps", "/static/ressources/mfpi_gris_print_petit.eps", "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_grand.png", "/static/ressources/mfpi_gris_numerique_grand.png", "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_moyen.png", "/static/ressources/mfpi_gris_numerique_moyen.png", "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_petit.png", "/static/ressources/mfpi_gris_numerique_petit.png", "LogoEsipeCustomPack/print/mfpi_blanc_print_grand.eps", "/static/ressources/mfpi_blanc_print_grand.eps", "LogoEsipeCustomPack/print/mfpi_blanc_print_moyen.eps", "/static/ressources/mfpi_blanc_print_moyen.eps", "LogoEsipeCustomPack/print/mfpi_blanc_print_petit.eps", "/static/ressources/mfpi_blanc_print_petit.eps", "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_grand.png", "/static/ressources/mfpi_blanc_numerique_grand.png", "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_moyen.png", "/static/ressources/mfpi_blanc_numerique_moyen.png", "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_petit.png", "/static/ressources/mfpi_blanc_numerique_petit.png"],
      formation_array: ["", "", "", "", "", ""],
      couleur_array: ["", "", "", "", "", ""],
      support_array: ["", "", "", "", "", ""],
      taille_array: ["", "", "", "", "", ""],
      size_grand: "210mm*297mm & 2048px*2048px",
      size_moyen: "105mm*148mm & 1024px*1024px",
      size_petit: "52mm*75mm & 512px*512px",
      choix_formation: "Toutes les formations",
      choix_couleur: "Toutes les couleurs",
      choix_support: "Tous les supports",
      choix_taille: "Toutes les tailles"
    };
  },

  methods: {
    toggleActive: function toggleActive(id) {
      var d = document.getElementById(id);
      d.classList.toggle("isactive");
    },
    toggleHidden: function toggleHidden(string) {
      var b = document.getElementById("overflow");
      console.log(b);
      this.is_hidden = !this.is_hidden;
      if (this.is_hidden == true) {
        b.style.overflow = 'visible';
      } else {
        b.style.overflow = 'hidden';
      }
      this.image = string;
      return this.is_hidden;
    },
    isEmpty: function isEmpty(array) {
      var zero_count = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i] == "0") {
          zero_count++;
        }
      }
      if (zero_count == array.length) {
        return true;
      } else {
        return false;
      }
    },
    editFormationArray: function editFormationArray(value, string) {
      for (var i = 0; i < this.formation_array.length; i++) {
        if (i == value) {
          if (this.formation_array[i] == "" || this.formation_array[i] == "0") {
            this.formation_array[i] = string;
          } else {
            this.formation_array[i] = "0";
          }
        } else if (this.formation_array[i] == "") {
          this.formation_array[i] = "0";
        }
      }
      if (this.isEmpty(this.formation_array)) {
        for (var i = 0; i < this.formation_array.length; i++) {
          this.formation_array[i] = "";
        }
        this.choix_formation = "Toutes les formations";
      } else {
        this.choix_formation = "";
        for (var i = 0; i < this.formation_array.length; i++) {
          if (this.formation_array[i] != "0") {
            this.choix_formation += this.formation_array[i] + "  ";
          }
        }
      }
      return this.formation_array;
    },
    editCouleurArray: function editCouleurArray(value, string) {
      for (var i = 0; i < this.couleur_array.length; i++) {
        if (i == value) {
          if (this.couleur_array[i] == "" || this.couleur_array[i] == "0") {
            this.couleur_array[i] = string;
          } else {
            this.couleur_array[i] = "0";
          }
        } else if (this.couleur_array[i] == "") {
          this.couleur_array[i] = "0";
        }
      }
      if (this.isEmpty(this.couleur_array)) {
        for (var i = 0; i < this.couleur_array.length; i++) {
          this.couleur_array[i] = "";
        }
        this.choix_couleur = "Toutes les couleurs";
      } else {
        this.choix_couleur = "";
        for (var i = 0; i < this.couleur_array.length; i++) {
          if (this.couleur_array[i] != "0") {
            this.choix_couleur += this.couleur_array[i] + "  ";
          }
        }
      }
      return this.couleur_array;
    },
    editSupportArray: function editSupportArray(value, string) {
      for (var i = 0; i < this.support_array.length; i++) {
        if (i == value) {
          if (this.support_array[i] == "" || this.support_array[i] == "0") {
            this.support_array[i] = string;
          } else {
            this.support_array[i] = "0";
          }
        } else if (this.support_array[i] == "") {
          this.support_array[i] = "0";
        }
      }
      if (this.isEmpty(this.support_array)) {
        for (var i = 0; i < this.support_array.length; i++) {
          this.support_array[i] = "";
        }
        this.choix_support = "Tous les supports";
      } else {
        this.choix_support = "";
        for (var i = 0; i < this.support_array.length; i++) {
          if (this.support_array[i] != "0") {
            this.choix_support += this.support_array[i] + "  ";
          }
        }
      }
      if (this.support_array[0] == "print" && this.support_array[1] == "0") {
        this.size_grand = "210mm*297mm";
        this.size_moyen = "105mm*148mm";
        this.size_petit = "52mm*75mm";
      } else if (this.support_array[0] == "0" && this.support_array[1] == "numerique") {
        this.size_grand = "2048px*2048px";
        this.size_moyen = "1024px*1024px";
        this.size_petit = "512px*512px";
      } else if (this.support_array[0] == "print" && this.support_array[1] == "numerique") {
        this.size_grand = "210mm*297mm & 2048px*2048px";
        this.size_moyen = "105mm*148mm & 1024px*1024px";
        this.size_petit = "52mm*75mm & 512px*512px";
      } else if (this.support_array[0] == "" && this.support_array[1] == "") {
        this.size_grand = "210mm*297mm & 2048px*2048px";
        this.size_moyen = "105mm*148mm & 1024px*1024px";
        this.size_petit = "52mm*75mm & 512px*512px";
      }
      return this.support_array;
    },
    editTailleArray: function editTailleArray(value, string) {
      for (var i = 0; i < this.taille_array.length; i++) {
        if (i == value) {
          if (this.taille_array[i] == "" || this.taille_array[i] == "0") {
            this.taille_array[i] = string;
          } else {
            this.taille_array[i] = "0";
          }
        } else if (this.taille_array[i] == "") {
          this.taille_array[i] = "0";
        }
      }
      if (this.isEmpty(this.taille_array)) {
        for (var i = 0; i < this.taille_array.length; i++) {
          this.taille_array[i] = "";
        }
        this.choix_taille = "Toutes les tailles";
      } else {
        this.choix_taille = "";
        for (var i = 0; i < this.taille_array.length; i++) {
          if (this.taille_array[i] != "0") {
            this.choix_taille += this.taille_array[i] + "  ";
          }
        }
      }
      return this.taille_array;
    },
    handler: function handler(array, id, value, string) {
      this.toggleActive(id);
      if (array == 0) {
        this.editFormationArray(value, string);
      } else if (array == 1) {
        this.editCouleurArray(value, string);
      } else if (array == 2) {
        this.editSupportArray(value, string);
      } else if (array == 3) {
        this.editTailleArray(value, string);
      }

      console.log("formation " + this.formation_array);
      console.log("couleur " + this.couleur_array);
      console.log("support " + this.support_array);
      console.log("taille " + this.taille_array);
    },
    triggerDownload: function triggerDownload() {
      var zip = new __WEBPACK_IMPORTED_MODULE_1__node_modules_jszip_dist_jszip_min_js___default.a();
      var zipArray = [];
      var zero_count = 0;

      for (var i = 0; i < this.ressources_array.length; i = i + 2) {
        for (var k = 0; k < this.formation_array.length; k++) {
          if (this.ressources_array[i].toLowerCase().indexOf(this.formation_array[k]) !== -1) {
            for (var k = 0; k < this.couleur_array.length; k++) {
              if (this.ressources_array[i].toLowerCase().indexOf(this.couleur_array[k]) !== -1) {
                for (var k = 0; k < this.support_array.length; k++) {
                  if (this.ressources_array[i].toLowerCase().indexOf(this.support_array[k]) !== -1) {
                    for (var k = 0; k < this.taille_array.length; k++) {
                      if (this.ressources_array[i].toLowerCase().indexOf(this.taille_array[k]) !== -1) {
                        zipArray.push(this.ressources_array[i], this.ressources_array[i + 1]);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      function urlToPromise(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_2__node_modules_jszip_lib_jszip_utils_js___default.a.getBinaryContent(url, function (err, data) {
            if (err) {
              reject(err);
            } else {
              resolve(data);
            }
          });
        });
      }

      var filename = "";
      var url = "";

      for (var i = 0; i < zipArray.length - 1; i = i + 2) {
        filename = zipArray[i];
        url = zipArray[i + 1];
        zip.file(filename, urlToPromise(url), { binary: true });
      }

      zip.generateAsync({ type: "blob" }).then(function (blob) {
        __WEBPACK_IMPORTED_MODULE_3__node_modules_file_saver_FileSaver_min_js___default.a.saveAs(blob, "LogosEsipeCustomPack.zip");
      });
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(41);

__webpack_require__(35);
__webpack_require__(36);
__webpack_require__(22);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var root_path = "";
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: root_path + '/',
		component: __webpack_require__(38)
	}, {
		path: root_path + '/ressources',
		component: __webpack_require__(40)
	}, {
		path: root_path + '/processing',
		component: __webpack_require__(39)
	}, {
		path: root_path + '/jingle',
		component: __webpack_require__(37)
	}, {
		path: '*',
		redirect: root_path + '/'
	}]
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	el: '#app',
	router: router,
	render: function render(h) {
		return h(__webpack_require__(13));
	}
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "popup",
    class: {
      hidden: _vm.is_hidden
    },
    on: {
      "click": function($event) {
        _vm.toggleHidden()
      }
    }
  }, [_c('div', {
    staticClass: "popup_content"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: " home_content container"
  }, [_c('h1', [_vm._v("Accès aux ressources : Logos ESIPE")]), _vm._v(" "), _c('div', {
    staticClass: "banner row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/eisc_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/eisc_rvb_numerique_petit.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/gc_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/gc_rvb_numerique_petit.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/gm_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/gm_rvb_numerique_petit.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/imac_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/imac_rvb_numerique_petit.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/info_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/info_rvb_numerique_petit.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4",
    on: {
      "click": function($event) {
        _vm.toggleHidden('/static/ressources/mfpi_rvb_numerique_petit.png')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/ressources/mfpi_rvb_numerique_petit.png"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "custom"
  }, [_c('h2', [_vm._v("Aucun pack ne vous convient ? Créez le vôtre !")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("Formation ESIPE")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "eisc"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'eisc', 0, 'eisc')
      }
    }
  }, [_c('p', [_vm._v("EISC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "gm"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'gm', 1, 'gm')
      }
    }
  }, [_c('p', [_vm._v("GM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "gc"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'gc', 2, 'gc')
      }
    }
  }, [_c('p', [_vm._v("GC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "imac"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'imac', 3, 'imac')
      }
    }
  }, [_c('p', [_vm._v("IMAC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "info"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'info', 4, 'info')
      }
    }
  }, [_c('p', [_vm._v("INFO")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2  download_block",
    attrs: {
      "id": "mfpi"
    },
    on: {
      "click": function($event) {
        _vm.handler(0, 'mfpi', 5, 'mfpi')
      }
    }
  }, [_c('p', [_vm._v("MFPI")])]), _vm._v(" "), _c('h3', [_vm._v("Couleur")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-3  download_block",
    attrs: {
      "id": "rvb"
    },
    on: {
      "click": function($event) {
        _vm.handler(1, 'rvb', 0, 'rvb')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-3  download_block",
    attrs: {
      "id": "cmjn"
    },
    on: {
      "click": function($event) {
        _vm.handler(1, 'cmjn', 1, 'cmjn')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-3  download_block",
    attrs: {
      "id": "gris"
    },
    on: {
      "click": function($event) {
        _vm.handler(1, 'gris', 2, 'gris')
      }
    }
  }, [_c('p', [_vm._v("Niveau de gris")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-3  download_block",
    attrs: {
      "id": "blanc"
    },
    on: {
      "click": function($event) {
        _vm.handler(1, 'blanc', 3, 'blanc')
      }
    }
  }, [_c('p', [_vm._v("Blanc")])]), _vm._v(" "), _c('h3', [_vm._v("Support")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6  col-sm-6 download_block",
    attrs: {
      "id": "print"
    },
    on: {
      "click": function($event) {
        _vm.handler(2, 'print', 0, 'print')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6  download_block",
    attrs: {
      "id": "numerique"
    },
    on: {
      "click": function($event) {
        _vm.handler(2, 'numerique', 1, 'numerique')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('h3', [_vm._v("Taille")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 download_block",
    attrs: {
      "id": "grand"
    },
    on: {
      "click": function($event) {
        _vm.handler(3, 'grand', 0, 'grand')
      }
    }
  }, [_c('p', [_vm._v("Grand "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.size_grand) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 download_block",
    attrs: {
      "id": "moyen"
    },
    on: {
      "click": function($event) {
        _vm.handler(3, 'moyen', 1, 'moyen')
      }
    }
  }, [_c('p', [_vm._v("Moyen "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.size_moyen) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 download_block",
    attrs: {
      "id": "petit"
    },
    on: {
      "click": function($event) {
        _vm.handler(3, 'petit', 2, 'petit')
      }
    }
  }, [_c('p', [_vm._v("Petit "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.size_petit) + ")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "download_pack"
  }, [_c('h2', [_vm._v("Votre pack à télécharger")]), _vm._v(" "), _c('h3', [_vm._v("Dans votre pack :")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Formation(s) :")]), _vm._v(" " + _vm._s(_vm.choix_formation))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Couleur(s) :")]), _vm._v(" " + _vm._s(_vm.choix_couleur))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Support(s) :")]), _vm._v(" " + _vm._s(_vm.choix_support))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Taille(s) :")]), _vm._v(" " + _vm._s(_vm.choix_taille))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 download_block custom_dl",
    on: {
      "click": function($event) {
        _vm.triggerDownload()
      }
    }
  }, [_c('p', [_vm._v("Télécharger votre pack !")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Clic droit > Enregistrer l'image sous pour obtenir l'image avec les propriétés suivantes :"), _c('br'), _vm._v("\n        rvb 72dpi 512px*512px\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack"
  }, [_c('h2', [_vm._v("Packs de logos prêt à l'emploi")]), _vm._v(" "), _c('p', [_vm._v("\n        Cliquez sur le pack qui vous convient. Un dossier compressé (.zip) contenant les fichiers vous sera fourni.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/packs/LogoEsipePackNumerique.zip",
      "download": "LogoEsipePackNumerique"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack"
  }, [_c('h3', [_vm._v("Pack Numérique")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-5x fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Contient les fichiers .PNG 72 dpi pour les documents numériques.       \n        ")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/packs/LogoEsipePackPrint.zip",
      "download": "LogoEsipePackPrint"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack"
  }, [_c('h3', [_vm._v("Pack Print")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-5x fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Contient les fichiers .EPS pour les \n        documents destinés à l'impression.       \n        ")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/packs/LogoEsipePackComplet.zip",
      "download": "LogoEsipePackComplet"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack"
  }, [_c('h3', [_vm._v("Pack complet")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-5x fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Contient l'ensemble des ressources disponibles.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Cliquez sur les options qui vous conviennent.\n      Un pack vous sera proposé en téléchargement.\n      "), _c('br'), _vm._v("\n      Laissez un champ sans sélection s'il n'est\n      n'est pas important pour vous. \n      Le pack contiendra l'option par défaut.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("RVB "), _c('span', [_vm._v("(numérique)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("CMJN "), _c('span', [_vm._v("(print)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Print "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(.eps 300dpi)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Numérique "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(.png 72dpi)")])])
}]}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "processing"
  }, [_c('div', {
    staticClass: " processing_content container"
  }, [_c('h1', [_vm._v("Processing")]), _vm._v(" "), _c('p', [_vm._v("\n      Téléchargez les exécutables correspondant à votre système d'exploitation ou bien le code source (.zip). Pour ce dernier Processing est nécéssaire.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/video/processing.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "download_processing col-md-6"
  }, [_c('div', {
    staticClass: "download_block"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/static/processing/LogoImacExecutableWindows.zip",
      "download": "LogoImacExecutableWindows"
    }
  }, [_vm._v("Windows (.zip)")])])]), _vm._v(" "), _c('div', {
    staticClass: "download_block"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/static/processing/LogoImacExecutableLinux.zip",
      "download": "LogoImacExecutableLinux"
    }
  }, [_vm._v("Linux (.zip)")])])]), _vm._v(" "), _c('div', {
    staticClass: "download_block"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/static/processing/LogoImacSource.zip",
      "download": "LogoImacSource"
    }
  }, [_vm._v("Source (.zip)")])])])])])])])
}]}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "container presentation_content"
  }, [_c('h1', [_vm._v("Présentation des nouveaux logos")]), _vm._v(" "), _c('div', {
    staticClass: "presentation_row row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Logo IMAC")]), _vm._v(" "), _c('p', [_vm._v("\n          La création d'un nouveau logo pour la formation IMAC est née de l'intention pour sa direction d'avoir une image \n          qui rejoigne le plus possible ses valeurs : Créativité, diversité, solidarité, la convergence des arts et des sciences,\n          d'une troisième culture liée au numérique.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Pour coller à cette envie, il a été imaginé un logo génératif, c'est-à-dire, un logo soutenu par un algorithme qui soit\n          à la fois artistique et technique. Le logo se compose en 3 chevrons de 3 couleurs différentes correspondant aux couleurs\n          primaires de la lumière : Le rouge, le vert et le bleu. L'orientation et la couleur des chevrons sont variables donnant \n          au logo un incroyable nombre de possibilités.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Ces trois chevrons condensent en elles toutes les valeurs de l'IMAC. Créativité de part la richesse des couleurs. \n          Diversité avec le nombre de possibilités au niveau des couleurs et orientions des chevrons évoquant la polyvalence qu'offre la formation.\n          Solidarité, les chevrons se soutiennent, se complètent, s'entremêlent comme l'IMAC qui croise différents domaines comme les arts, les sciences \n          et la communication. Enfin, le logo est codé avec un langage de programmation. Il porte dans son ADN le croisement entre les arts et les sciences. \n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/pdf/CharteGraphiqueLogoImac.pdf",
      "download": "CharteGraphiqueLogoImac"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 download_block charte_dl",
    on: {
      "click": function($event) {
        _vm.triggerDownload()
      }
    }
  }, [_c('p', [_vm._v("Télécharger la charte du logo.")])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image col-md-offset-1 col-md-5"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/IMAC_logo_large.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_row row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Normalisation des logos ESIPE")]), _vm._v(" "), _c('p', [_vm._v("\n          Les logos ESIPE avaient besoin d'être normalisés. Une grille a été créée pour que tous les logos aient la même construction. \n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Un changement de typographie a également été fait. Poppins a été choisie car elle est très géométrique, droite précise. Il fallait\n          une police qui corresponde à l'idée d'ingénieur.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Aussi, une nouvelle formation fait son apparition : INFO. Fusion des anciennes formations IR et IG, le logo devait rester dans l'esprit de l'ensemble des autres logos.\n          Il a été choisi d'opter pour l'ordinateur portable et les accolades pour évoquer le numérique et la programmation. Dans l'écran nous retrouvons des marqueurs de localisation \n          pour symboliser la géomatique.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "image col-md-offset-1 col-md-5"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ESIPE_logo.png"
    }
  })])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Présentation")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ressources"
    }
  }, [_vm._v("Ressources")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/processing"
    }
  }, [_vm._v("Processing")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/jingle"
    }
  }, [_vm._v("Jingle")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('MainNav'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ingenieur-imac.fr/"
    }
  }, [_vm._v("Retour au site ingénieur IMAC")])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingle"
  }, [_c('div', {
    staticClass: " jingle_content container"
  }, [_c('h1', [_vm._v("Jingle")]), _vm._v(" "), _c('p', [_vm._v("\n      Téléchargez le Jingle pour l'inclure dans vos projets.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/OJvz0Lfe8-4",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_jingle col-lg-6 col-md-12 col-sm-12"
  }, [_c('div', {
    staticClass: "download_block"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/static/video/LogoImacJingle.mp4",
      "download": "LogoImacJingle"
    }
  }, [_vm._v("Vidéo (.mp4)")])])])])
}]}

/***/ })
],[50]);


// WEBPACK FOOTER //
// static/js/app.d0b75cb03bbdc88e5cd8.js